module.exports = __webpack_public_path__ + "img/logo-tu.59f6f2fd.png";